__turbopack_context__.v({
  "linksCont": "QuickLinks-module___2UNoG__linksCont",
  "wrpr": "QuickLinks-module___2UNoG__wrpr",
});
